import { render } from "./AdminGraphite.vue?vue&type=template&id=63c80870&scoped=true"
import script from "./AdminGraphite.vue?vue&type=script&lang=js"
export * from "./AdminGraphite.vue?vue&type=script&lang=js"

import "./AdminGraphite.vue?vue&type=style&index=0&id=63c80870&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63c80870"]])

export default __exports__